module.exports = __webpack_public_path__ + "img/svg/background-login-mobile.c82ff5fa24e72b68e26fc81577c0d9ac.svg";